import { Outlet } from "react-router";

const VeticServiceDeskIndex = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default VeticServiceDeskIndex;
